<template>
  <div>
    <job-request-section-heading v-if="title">
      {{ title }}
    </job-request-section-heading>
    <div class="d-flex fd-column:mo">
      <!-- Selection Options -->
      <label
          v-for="(option, index) in options"
          :key="index"
          :class="{
            CHECKED: value === option.value,
            DISABLED: disabled
          }"
          :selenium="`radio-selection:${index + 1}`"
          class="RADIOBOX cur-pointer">
        <input
            :value="option.value"
            :disabled="disabled"
            class="d-none"
            type="radio"
            name="radio"
            @change="$emit('change', option.value)">

        <div class="d-flex ai-center jc-start:mo p-x-2 p-x-5:mo p-y-3:t p-y-2:mo w-100">
          <vk-icon :name="option.icon" :size="option.size" class="flex-0-0:mo m-r-4"/>
          <span class="OPTION-TEXT text-center:t m-x-2:mo">{{ option.text }}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import JobRequestSectionHeading from '@/views/JobRequest/components/JobRequestSectionHeading';

export default {
  name: 'radio-selection',
  components: {
    JobRequestSectionHeading,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .RADIOBOX {
    display: flex;
    color: $color-gray70;
    border: 2px solid $color-gray50;
    background-color: white;
    cursor: pointer;

    &:hover:not(.CHECKED):not(.DISABLED) {
      box-shadow: inset 0 0 0 3px $color-gray50;
      transition: all 0.1s ease-in-out;
    }

    & + & {
      @include margin-left(0, 2);
      @include margin-top(2, 0);
    }

    @include tablet {
      @include rect(345px, 90px);
    }
  }

  .OPTION-TEXT {
    @include tablet {
      @include margin-top(1);
    }
    font-size: 20px;
    width: 150px;
  }

  .CHECKED:not(.DISABLED) {
    color: $color-depot;
    border: none;
    box-shadow: inset 0 0 0 3px $color-depot;
    transition: all 0.1s ease-in-out;

    .OPTION-TEXT {
      color: black;
      font-size: 20px;
    }
  }

  .CHECKED.DISABLED {
    box-shadow: inset 0 0 0 3px $color-gray50;
  }
</style>
